import React, { memo } from "react";
import { Dropdown } from "react-bootstrap";

import { EXPORT_TYPE } from "../../../system/global-enums";

const ExportDropdown = memo(({ className = "", onExport }) => {
  return (
    <Dropdown className={`export-dropdown ${className}`}>
      <Dropdown.Toggle aria-label="Export CSV">Export CSV</Dropdown.Toggle>
      <Dropdown.Menu className="text-center shadow ">
        <Dropdown.Item onClick={() => onExport(EXPORT_TYPE.ALL)}>
          All data
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => onExport(EXPORT_TYPE.GRID)}>
          Grid data
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
});

export default ExportDropdown;
